import { push } from "connected-react-router";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { ROUTE_PATH, APPLICATION_MODE_NEW } from "../../../app/constants";
import { setMortgageProperty } from "../../../redux/slice/primaryAgencyApplicationSlice";
import { Button } from "../../../components/RegularComponents";
import TopNavigationBar from "../../TopNavigationBar";
import { applicationTypeFromLicenceSubType } from "../../../redux/slice/applicationsUtils";
import { usePathApplication } from "../../../redux/hooks/usePathApplication";
import { agencyApplicationSelector } from "../../../redux/selector/agencyApplicationSelector";

const MORTGAGE_APPLICATION_PROPERTY = "licenceAnotherProvince";

export const exemptProvinces = [
  "British Columbia",
  "Alberta",
  "Saskatchewan",
  "Manitoba",
  "Ontario",
  "Quebec",
  "New Brunswick"
];

const exemptProvincesBroker = [
  "Submortgage Broker, British Columbia",
  "Mortgage Broker, Alberta",
  "Mortgage Broker, Saskatchewan",
  "Authorized Official, Manitoba",
  "Mortgage Broker, Ontario",
  "Mortgage Broker, Quebec",
  "Mortgage Broker, New Brunswick"
];

export const MainAgentLicenceInProvinces = (props) => {
  const { application } = usePathApplication();
  // const isPrincipalBroker =  (ROUTE_PATH.PB_APP.search(application) !== -1);
  const { agencyApplication } = useSelector(agencyApplicationSelector) || {};
  const licencingSubType = agencyApplication?.licencingSubType;

  const dispatch = useDispatch();

  const handleNext = (licenceAnotherProvince) => {
    dispatch(
      setMortgageProperty({
        key: MORTGAGE_APPLICATION_PROPERTY,
        value: licenceAnotherProvince
      })
    );

    // reset if previously is provided in the flow
    if (agencyApplication?.businessLicenceData?.mblraLicenceNumber) {
      dispatch(
        setMortgageProperty({
          key: "mblraLicenceNumber",
          value: null
        })
      );
    }

    const nextPath = licenceAnotherProvince
      ? ROUTE_PATH.MRA_ADD_MAIN_AGENT_BROKER_INFORMATION
      : ROUTE_PATH.MRA_ADD_MAIN_AGENT_LICENCE_NUMBER;
    dispatch(push(`/${application}${nextPath}`));
  };

  return (
    <div className="container">
      {/* Title */}
      <TopNavigationBar
        {...props}
        applicationType={applicationTypeFromLicenceSubType(licencingSubType)}
        applicationMode={APPLICATION_MODE_NEW}
      />
      <div className="row">
        <div className="col-xs-12 col-lg-10">
          <h1>Do you have at least 1 current licence from this list?</h1>
        </div>
      </div>
      {/* Information Paragraphs */}
      <div className="row">
        <div className="col-lg-8">
          <ul style={{ lineHeight: "2.5em" }}>
            {exemptProvincesBroker.sort().map((p) => (
              <li>{p}</li>
            ))}
          </ul>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-lg-10">
          {`If yes, you are exempt from completing the Nova Scotia Mortgage Broker Education Program.`}
        </div>
      </div>
      {/* Yes/No Answer */}
      <div className="row">
        <div className="col-lg-2 ">
          <Button
            className="ns-btn-yes-no"
            buttonType="regular_primary"
            onClick={() => {
              handleNext(true);
            }}
            text={"Yes"}
          />
        </div>

        <div className="col-lg-2">
          <Button
            className="ns-btn-yes-no"
            buttonType="regular_primary"
            onClick={() => {
              handleNext(false);
            }}
            value={false}
            text={"No"}
          />
        </div>
      </div>
    </div>
  );
};
